import { render, staticRenderFns } from "./DocutaxRequestList.vue?vue&type=template&id=f89256a4&scoped=true&"
import script from "./DocutaxRequestList.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89256a4",
  null
  
)

export default component.exports